export default __webpack_public_path__ + "static/media/waLogo.996b65a8.png";